import type { LucideProps } from 'lucide-react';

export const DEFAULT_LUCIDE_ICON_PROPS: LucideProps = {
  strokeWidth: 1.5,
  absoluteStrokeWidth: true,
};

const LucideIconName = ['Menu', 'Search', 'X', 'RefreshCw', 'Clock', 'ChevronRight', 'Mail'] as const;

export type LucideIconName = (typeof LucideIconName)[number];
